import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { isEqual } from "lodash-es"
import {
  getFacilityIdMap,
  getNoLocationAnswerOptionChecked,
  setNoLocationAnswerOption,
  shownDepartmentCountsByFacility,
} from "reduxSlices/formSubmissionTableSlice"
import { Checkbox } from "shared/checkboxes"
import ItemRow from "shared/ItemRow"
import FacilityFilter from "./FacilityFilter"

const SubmissionAnswerLocationList = () => {
  const dispatch = useDispatch()

  const facilities = useSelector(getFacilityIdMap, isEqual)
  const departmentCounts = useSelector(shownDepartmentCountsByFacility, isEqual)

  const noLocationAnswerOptionChecked = useSelector(getNoLocationAnswerOptionChecked)
  const noLocationAnswerLabel = "no-location-answer-option"

  return (
    <div className="flex flex-col">
      {Object.values(facilities).map((facility) => (
        <FacilityFilter
          key={facility.id}
          facility={facility}
          visibleDepartmentCount={departmentCounts[facility.id]?.visible || 0}
          totalDepartmentCount={departmentCounts[facility.id]?.total || 0}
        />
      ))}

      <ItemRow
        className="transparent border-lightgray-3 py-2"
        itemRowHeaderContentClassName="p-2 justify-start"
        itemRowHeaderContent={(
          <>
            <Checkbox
              uuid={noLocationAnswerLabel}
              className="shrink-0"
              value={noLocationAnswerOptionChecked}
              onChange={() => dispatch(
                setNoLocationAnswerOption(!noLocationAnswerOptionChecked),
              )}
            />
            <label htmlFor={noLocationAnswerLabel}>
              <span className="text-sm font-medium ml-2">
                No Location Answers
              </span>
            </label>
          </>
        )}
      />
    </div>
  )
}

export default SubmissionAnswerLocationList
